
import './ScenarioSteps.scss'
import { Fragment, useMemo } from "react"
import ScenarioDetails from "./details/ScenarioDetails"
import ScenarioSatellites from "./satellite/ScenarioSatellites"
import GroundSegments from "./segments/GroundSegments"
import InitialAltitude from "./initial-altitude/InitialAltitude"
import HWILComponents from "./hwil/HWILComponents"
import GeoFeatures from "./features/GeoFeatures"
import ScenarioSchedule from "./schedule/ScenarioSchedule"
import FaultInjection from "./fault/FaultInjection"
import GeneratedAssets from "./assets/GeneratedAssets"
import useScenarioResponse from "../../hooks/useScenarioResponse"
import useStepper from "../../hooks/useStepper"
import useForm from '../../hooks/useForm'
import { SCENARIO_STEPS, SCENARIO_DEPLOYMENT_TYPES, SCENARIO_OPERATION_TYPES, SCENARIO_STATUS } from "../../../constants"
import useNavigation from '../../hooks/useNavigation'
import { getHiddenStatus } from '../../utils/helperFunction'

const ScenarioSteps = () => {
    const { formData } = useForm()
    const { step } = useNavigation()
    const { openScenario, scenarioResponse } = useScenarioResponse()
    const { updateScenarioStep, checkActiveStep, checkStepCompleted, checkDisabledSteps } = useStepper()
    const scenarioOperationType = useMemo(() => formData.details.scenarioOperation, [formData.details.scenarioOperation])
    const scenarioDeploymentType = useMemo(() => formData.details.scenarioDeploymentType, [formData.details.scenarioDeploymentType])

    return (
        <Fragment>
            <ScenarioDetails
                title="Scenario Details"
                open={checkActiveStep(SCENARIO_STEPS.DETAILS)}
                stepCompleted={checkStepCompleted(SCENARIO_STEPS.DETAILS)}
                disabled={checkDisabledSteps(SCENARIO_STEPS.DETAILS)}
                onToggle={() => updateScenarioStep(SCENARIO_STEPS.DETAILS)}
            />
            <ScenarioSatellites
                title="Satellites"
                open={checkActiveStep(SCENARIO_STEPS.SATELLITES)}
                stepCompleted={checkStepCompleted(SCENARIO_STEPS.SATELLITES)}
                disabled={checkDisabledSteps(SCENARIO_STEPS.SATELLITES)}
                hideComponent={getHiddenStatus(SCENARIO_STEPS.SATELLITES, scenarioOperationType, scenarioDeploymentType, openScenario)}
                onToggle={() => updateScenarioStep(SCENARIO_STEPS.SATELLITES)}
            />
            <InitialAltitude
                title="Initial Attitude Conditions"
                open={checkActiveStep(SCENARIO_STEPS.INITIAL_ALTITUDE)}
                disabled={checkDisabledSteps(SCENARIO_STEPS.INITIAL_ALTITUDE)}
                stepCompleted={checkStepCompleted(SCENARIO_STEPS.INITIAL_ALTITUDE)}
                hideComponent={getHiddenStatus(SCENARIO_STEPS.INITIAL_ALTITUDE, scenarioOperationType, scenarioDeploymentType, openScenario)}
                onToggle={() => updateScenarioStep(SCENARIO_STEPS.INITIAL_ALTITUDE)}
            />

            <HWILComponents
                title="HWIL Components"
                open={checkActiveStep(SCENARIO_STEPS.HWIL)}
                disabled={checkDisabledSteps(SCENARIO_STEPS.HWIL)}
                stepCompleted={checkStepCompleted(SCENARIO_STEPS.HWIL)}
                hideComponent={getHiddenStatus(SCENARIO_STEPS.HWIL, scenarioOperationType, scenarioDeploymentType, openScenario)}
                onToggle={() => updateScenarioStep(SCENARIO_STEPS.HWIL)}
            />
            <GroundSegments
                title="Ground Segments"
                open={checkActiveStep(SCENARIO_STEPS.SEGMENTS)}
                disabled={checkDisabledSteps(SCENARIO_STEPS.SEGMENTS)}
                stepCompleted={checkStepCompleted(SCENARIO_STEPS.SEGMENTS)}
                hideComponent={getHiddenStatus(SCENARIO_STEPS.SEGMENTS, scenarioOperationType, scenarioDeploymentType, openScenario)}
                onToggle={() => updateScenarioStep(SCENARIO_STEPS.SEGMENTS)}
            />
            <GeoFeatures
                title="GeoFeatures"
                open={checkActiveStep(SCENARIO_STEPS.FEATURES)}
                disabled={true}
                stepCompleted={checkStepCompleted(SCENARIO_STEPS.FEATURES)}
                hideComponent={true}
                onToggle={() => updateScenarioStep(SCENARIO_STEPS.FEATURES)}
            />
            <ScenarioSchedule
                title={scenarioOperationType === SCENARIO_OPERATION_TYPES.LEOP ? "Simulation Details" : "Schedule"}
                open={checkActiveStep(SCENARIO_STEPS.SCHEDULE)}
                disabled={checkDisabledSteps(SCENARIO_STEPS.SCHEDULE)}
                stepCompleted={checkStepCompleted(SCENARIO_STEPS.SCHEDULE)}
                hideComponent={getHiddenStatus(SCENARIO_STEPS.SCHEDULE, scenarioOperationType, scenarioDeploymentType, openScenario)}
                onToggle={() => updateScenarioStep(SCENARIO_STEPS.SCHEDULE)}
            />
            <FaultInjection
                title="Fault Plans"
                open={checkActiveStep(SCENARIO_STEPS.FAULTS)}
                disabled={checkDisabledSteps(SCENARIO_STEPS.FAULTS)}
                stepCompleted={checkStepCompleted(SCENARIO_STEPS.FAULTS)}
                hideComponent={getHiddenStatus(SCENARIO_STEPS.FAULTS, scenarioOperationType, scenarioDeploymentType, openScenario)}
                onToggle={() => updateScenarioStep(SCENARIO_STEPS.FAULTS)}
            />
            <GeneratedAssets
                title="Assets"
                open={checkActiveStep([SCENARIO_STEPS.ASSETS, SCENARIO_STEPS.DEPLOY, SCENARIO_STEPS.RECONNECT, SCENARIO_STEPS.CONNECT, SCENARIO_STEPS.START_SIMULATION].includes(step!) ? step! : SCENARIO_STEPS.ASSETS)}
                disabled={checkDisabledSteps(SCENARIO_STEPS.ASSETS)}
                stepCompleted={checkStepCompleted(SCENARIO_STEPS.ASSETS)}
                hideComponent={getHiddenStatus(SCENARIO_STEPS.ASSETS, scenarioOperationType, scenarioDeploymentType, openScenario)}
                onToggle={() => {
                    const assetNextStep = scenarioDeploymentType === SCENARIO_DEPLOYMENT_TYPES.HARDWARE_IN_LOOP ? scenarioResponse?.status === SCENARIO_STATUS.HWIL_CONFIG_GENERATED ? SCENARIO_STEPS.CONNECT : scenarioResponse?.status === SCENARIO_STATUS.WAITING_FOR_CONNECTION ? SCENARIO_STEPS.RECONNECT : SCENARIO_STEPS.ASSETS : SCENARIO_STATUS.READY_FOR_SIMULATION ? SCENARIO_STEPS.DEPLOY : SCENARIO_STEPS.ASSETS
                    updateScenarioStep(assetNextStep)
                }}
            />
        </Fragment>
    )
}

export default ScenarioSteps